export default {
  'component.country.allGroup': 'All Countries',
  'component.country.placeholder': 'Select country/region',
  'component.country.popularGroup': 'Popular Countries',
  'component.phonePrefix.allGroup': 'All',
  'component.phonePrefix.placeholder': 'Code',
  'component.phonePrefix.popularGroup': 'Popular',

  'component.copyText.copy': 'Click to copy',
  'component.copyText.copied': 'Copied',

  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',

  // ===== LLMMonitor =====
  'component.llmMonitor.title': 'LLM Calls',
  'component.llmMonitor.empty': 'No LLM calls',
  'component.llmMonitor.inFlight': 'In-flight {count}',
  'component.llmMonitor.queued': 'Queued {count}',
  'component.llmMonitor.lease': 'Lease {count}',
  'component.llmMonitor.loadFailed': 'Failed to load LLM monitor',

  // ===== Footer =====
  'component.footer.copyright': 'AI Drama Studio',

  // ===== HeaderDropdown =====
  'component.headerDropdown.profile': 'Profile',
  'component.headerDropdown.settings': 'Settings',
  'component.headerDropdown.logout': 'Logout',
  'component.logout.confirmTitle': 'Log out?',
  'component.logout.confirmDesc': 'Are you sure you want to log out?',
};
